export default __webpack_public_path__ + "static/media/girl_phone.6ebed6f2.png";